<template>
  <div class="container">
    <div class="order-detail">
      <div class="img_box">
        <img class="bhw_logo" src="../../assets/check_logo.png" alt="" />
      </div>
      <div class="title">货物明细页-按发货单查看</div>
      <div class="search_product_info"></div>
      <div class="d-line">
        <div class="d-label">收货人</div>
        <div class="d-info">sssfsdf</div>
      </div>
      <div class="d-line">
        <div class="d-label">物流</div>
        <div class="d-info">德邦乌璐</div>
      </div>
      <div class="d-line">
        <div class="d-label">发货仓库</div>
        <div class="d-info">济南云仓</div>
      </div>
      <div class="d-line">
        <div class="d-label">订单数量</div>
        <div class="d-info">123</div>
      </div>
    </div>
    <div class="goods_shipped">本单发货货品：</div>
    <div class="content">
      <div class="good-item" v-for="(item, index) in modelList" :key="index">
        <div class="good-content">
          <viewer>
            <img class="good-img wc-preview-img" :src="item.img" alt="" />
          </viewer>
          <div class="good-info">
            <div class="good-text">型号全称：{{ item.modelName }}</div>
            <div class="good-text">型号规格：{{ item.modelNeedSendType }}</div>
            <div class="good-text">数量：{{ item.allCount }}</div>
          </div>
        </div>
        <div class="btn-box">
          <el-button type="danger" plain class="small-btn">数量有误</el-button>
          <el-button type="success" plain class="small-btn">核对正确</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderId: "",
      orderDetail: [],
      modelList: [
        {
          modelName: "麻辣香锅",
          modelNeedSendType: "1/瓶 12/箱",
          allCount: 15,
          img: require("@/assets/banner1.jpg"),
        },
        {
          modelName: "麻辣香锅",
          modelNeedSendType: "1/瓶 12/箱",
          allCount: 15,
          img: require("@/assets/banner2.jpg"),
        },
        {
          modelName: "麻辣香锅",
          modelNeedSendType: "1/瓶 12/箱",
          allCount: 15,
          img: require("@/assets/banner3.jpg"),
        },
        {
          modelName: "麻辣香锅",
          modelNeedSendType: "1/瓶 12/箱",
          allCount: 15,
          img: require("@/assets/p1.jpg"),
        },
        {
          modelName: "麻辣香锅",
          modelNeedSendType: "1/瓶 12/箱",
          allCount: 15,
          img: require("@/assets/p2.jpg"),
        },
        {
          modelName: "麻辣香锅",
          modelNeedSendType: "1/瓶 12/箱",
          allCount: 15,
          img: require("@/assets/p3.jpg"),
        },
        {
          modelName: "麻辣香锅",
          modelNeedSendType: "1/瓶 12/箱",
          allCount: 15,
          img: require("@/assets/y1.png"),
        },
        {
          modelName: "麻辣香锅",
          modelNeedSendType: "1/瓶 12/箱",
          allCount: 15,
          img: require("@/assets/y2.png"),
        },
      ],
      tabIndex: "",
    };
  },
  onLoad(options) {
    this.tabIndex = options.tabIndex;
    this.orderId = options.orderId;
    this.getAllocateOrderDetail();
  },
  methods: {
    rejectRequest() {
      this.$businessApi
        .request("post", "/product/order/agreeNotRepOrderForFac", {
          id: this.orderId,
        })
        .then((res) => {
          if (res.data.code == 0) {
            console.log(res.data.dataInfo);
            var _thiz = this;
            uni.showToast({
              title: "已驳回",
              icon: "error",
              duration: 1500,
              mask: true,
              success() {
                setTimeout(function () {
                  uni.$emit("backTabIndex", _thiz.tabIndex);
                  uni.navigateBack({
                    delta: 1,
                  });
                }, 1500);
              },
            });
          } else {
            var _thiz = this;
            console.log(res.data);
            uni.showToast({
              title: res.data.msg,
              icon: "none",
            });
            uni.$emit("backTabIndex", _thiz.tabIndex);
          }
        })
        .catch((error) => {
          console.log("请求接口失败👇");
          console.log(error);
          uni.showToast({
            title: error.errMsg,
            icon: "none",
            success() {},
          });
        });
    },
    approved() {
      this.$businessApi
        .request("post", "/product/order/agreeRepOrderForFac", {
          id: this.orderId,
        })
        .then((res) => {
          if (res.data.code == 0) {
            console.log(res.data.dataInfo);
            var _thiz = this;
            uni.showToast({
              title: "已通过",
              icon: "success",
              duration: 1500,
              mask: true,
              success() {
                setTimeout(function () {
                  uni.$emit("backTabIndex", _thiz.tabIndex);
                  uni.navigateBack({
                    delta: 1,
                  });
                }, 1500);
              },
            });
          } else {
            var _thiz = this;
            console.log(res.data);
            uni.showToast({
              title: res.data.msg,
              icon: "none",
            });
            // uni.navigateBack({
            // 	delta: 1
            // });
            // uni.$emit('backTabIndex', _thiz.tabIndex)
          }
        })
        .catch((error) => {
          console.log("请求接口失败👇");
          console.log(error);
          uni.showToast({
            title: error.errMsg,
            icon: "none",
            success() {},
          });
        });
    },
    getAllocateOrderDetail() {
      //   this.$businessApi
      //     .request("post", "/product/order/repOrderSubInfoForFac", {
      //       id: this.orderId,
      //     })
      //     .then((res) => {
      //       if (res.data.code == 0) {
      //         this.modelList = res.data.dataInfo;
      //         this.orderDetail = res.data.repOrderInfo;
      //       } else {
      //         console.log(res.data);
      //         uni.showToast({
      //           title: res.data.msg,
      //           icon: "none",
      //         });
      //       }
      //     })
      //     .catch((error) => {
      //       uni.hideLoading();
      //       console.log("请求接口失败👇");
      //       console.log(error);
      //       uni.showToast({
      //         title: error.errMsg,
      //         icon: "none",
      //         success() {},
      //       });
      //     });
    },
    goSearce() {
      this.$router.push({ name: "searchPage" });
    },
  },
};
</script>

<style>
.el-button--success.is-plain,
.el-button--danger.is-plain {
  background: #fff !important;
  border-color: #ccc !important;
}
.el-button--success.is-plain:hover {
  border-color: #00a822 !important;
  color: #00a822 !important;
}
.el-button--danger.is-plain:hover {
  border-color: #f56c6c !important;
  color: #f56c6c !important;
}
</style>
<style lang="less" scoped>
.container {
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  width: 100%;
  position: relative;
  background-color: #f5f6f8;
  //   height: 100vh;
  .img_box {
    margin-bottom: 20px;
  }
  .bhw_logo {
    width: 136px;
    height: 32px;
    // margin-right: 20px;
  }
  .title {
    // width: 346px;
    height: 34px;
    line-height: 34px;
    background-color: #f5f5f5;
    text-align: center;
    font-size: 18px;
    margin-bottom: 10px;
  }
  .goods_shipped {
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    text-align: left;
    margin-left: 10px;
  }
  .order-detail {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    width: 100%;
    padding: 5px 0px;

    .d-line {
      display: flex;
      justify-content: space-between;
      line-height: 30px;
      font-size: 16px;
      padding-left: 10px;

      .d-label {
        width: 80px;
        text-align: left;
        color: #999999;
      }

      .d-info {
        width: 260px;
        text-align: left;
        color: #333333;
      }
    }
  }

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // padding: 0 5px;
    width: 100%;
    padding-bottom: 50px;
    // background-color: yellow;
    .good-item {
      width: 347px;
      // height: 424px;
      margin-bottom: 10px;

      //   border-radius: 10px;
      background-color: #ffffff;
      padding: 14px 14px;
      display: flex;
      flex-direction: column;
      .good-name {
        font-size: 18px;
        font-weight: 700;
        color: #333333;
        border-bottom: 1px solid #e8e9ec;
        padding-bottom: 14px;
        display: flex;
        align-items: center;
        .goodIcon {
          width: 40px;
          height: 44px;
          margin-right: 10px;
        }
        .name {
          width: 90%;
        }
      }

      .good-time {
        font-size: 32px;
        // color: $system-color;
        text-align: center;
        margin-top: 20px;
      }
      .good-content {
        // width: 654px;
        display: flex;
        justify-content: flex-start;
        // padding: 26px auto;
        padding-bottom: 12px;
        .good-img {
          width: 96px;
          height: 96px;
          margin-right: 10px;
          // background-color: #cccccc;
        }
        .good-info {
          width: fit-content;
          //   margin-left: 20px;
          display: flex;
          flex-direction: column;
          line-height: 30px;

          .good-text {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            color: #333333;
            font-size: 16px;
          }
        }
      }
    }
  }
  .btn-box {
    // padding: 0 14px;
    display: flex;
    justify-content: space-between;
    // position: fixed;
    // bottom: 100px;
    // left: 0;
    // right: 0;
    .small-btn {
      width: 170px;
      height: 50px;
      //   line-height: 50px;
      //   border-radius: 5px;
      //   background-color: #ffffff;
      color: #666666;
      //   text-align: center;
      font-size: 18px;
      font-weight: 500;
      //   border: 1px solid #e8e9ec;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/checkProduct/index.vue